import { defineMessages } from "react-intl";

export const translations = defineMessages({
  ContentNotHandledText: {
    id: "ContentNotHandled.ContentNotHandledText",
    defaultMessage: "The content of this page can not be managed by BackOffice",
  },
});
